// extracted by mini-css-extract-plugin
module.exports = {"press-list":"press_press-list__2VGST"};